import React from "react";
import { connect } from "react-redux";
import {
    roleHasPermission,
    mapStateToRolePermissions,
} from "utils/permissions/rolePermissions";

const TabbedWrapperAccessControl = ({
    baseResources,
    children,
    role,
}) => {
    const hasAccess = roleHasPermission(role, baseResources);

    return <>{hasAccess ? children : <></>}</>;
};

export default connect((state) => ({
    ...mapStateToRolePermissions(state),
    role: state?.auth?.user?.role,
}))(TabbedWrapperAccessControl);
